// extracted by mini-css-extract-plugin
export default {"container":"List_container__YV+sU","listContainer":"List_listContainer__wUt65","list":"List_list__MRjzN","listItem":"List_listItem__nm3x7"};